import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/staking_reverse.png'
import _imports_1 from '@/assets/images/staking.png'
import _imports_2 from '@/assets/images/waves2.png'


const _hoisted_1 = { class: "flex flex-col overflow-hidden md:overflow-visible" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "px-4 lg:px-32 md:px-20 py-24 grid grid-cols-5 md:grid-cols-2 container mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex md:hidden justify-center items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "-translate-x-7 translate-y-3/4 scale-150",
    src: _imports_0,
    alt: "Armony Finance Stacking"
  })
], -1)
const _hoisted_5 = { class: "col-span-3 md:col-span-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-6xl text-center md:text-left xl:mt-4 font-semibold text-[#19191B]" }, [
  /*#__PURE__*/_createTextVNode(" Armony "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" staking ")
], -1)
const _hoisted_7 = { class: "text-lg text-center md:text-left font-light mt-12 md:mt-8 text-[#696871]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "no" }, [
  /*#__PURE__*/_createTextVNode(" Put your crypto at work. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" With Armony you receive up to ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " APY on your stacked cryptocurrencies! ", -1)
const _hoisted_10 = { class: "flex md:justify-start justify-center items-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Start earning ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-start md:items-center relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "translate-x-7 translate-y-3/4 md:translate-y-0 md:translate-x-0 scale-150 md:scale-100 z-10",
    src: _imports_1,
    alt: "Armony Finance Stacking"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "hidden md:block absolute xl:right-0 scale-150 xl:scale-100 top-15 xl:-top-24 z-0",
    src: _imports_2,
    alt: "Armony waves"
  })
], -1)
const _hoisted_13 = { class: "container mx-auto my-16 lg:mt-32 lg:mb-32 lg:px-32 md:px-20 px-10 mt-16 pb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "text-[2.2rem] text-gray-900 leading-none tracking-wide text-center w-full font-semibold" }, " How Armony works? ", -1)
const _hoisted_15 = { class: "px-4 grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" }
const _hoisted_16 = { class: "text-[2.2rem] text-[#FF2AFF] font-semibold mb-8" }
const _hoisted_17 = { class: "md:hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shimmer = _resolveComponent("shimmer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_faq = _resolveComponent("faq")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h3", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_shimmer, {
                loading: !_ctx.staking_ready,
                text: `${_ctx.bestAPY} %`
              }, null, 8, ["loading", "text"]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/staking",
                class: "bg-[#FF2AFF] text-gray-50 h-12 px-8 mx-0.5 font-medium flex items-center mt-10 rounded-full"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_12
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.home.how_armony_works, (elem, id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: id,
            class: "col-span-1"
          }, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(elem.title), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(elem.body), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.home.how_armony_works, (elem, id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: id,
            class: "col-span-1 hidden md:block"
          }, [
            _createElementVNode("span", null, _toDisplayString(elem.body), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_faq, { class: "mt-10 mb-20" })
  ], 64))
}